import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Film, ChevronRight, PlayCircle } from "lucide-react";
import { endpoints, API_BASE } from "@/lib/api";
import { HighlightPlayer } from "@/components/football/Highlights";

const abs = (u) => (u && u.startsWith("/api/") ? `${API_BASE}${u}` : u);

// Clickable highlights strip shown above the radio player artwork.
export const HighlightsBar = ({ className = "" }) => {
  const [items, setItems] = useState([]);
  const [play, setPlay] = useState(null);
  const nav = useNavigate();
  useEffect(() => { endpoints.highlights(12).then((r) => setItems(r.data.highlights || [])).catch(() => {}); }, []);
  const open = (h) => (h.kind === "clip" ? setPlay(h) : nav(h.link));
  return (
    <div className={`rounded-2xl border border-[#273042] bg-[#121620] p-3 ${className}`} data-testid="radio-highlights-bar">
      <div className="flex items-center justify-between mb-2">
        <Link to="/highlights" className="text-sm font-extrabold text-white flex items-center gap-1.5 hover:text-[#E11D2A] transition-colors" data-testid="radio-highlights-link">
          <Film className="w-4 h-4 text-[#E11D2A]" /> Highlights videos</Link>
        <Link to="/highlights" className="text-xs text-slate-400 hover:text-white flex items-center" data-testid="radio-highlights-all">See all <ChevronRight className="w-3.5 h-3.5" /></Link>
      </div>
      {items.length === 0 ? <Link to="/highlights" className="block text-xs text-slate-500">Watch the latest goals and big moments →</Link> : (
        <div className="flex gap-2 overflow-x-auto snap-x pb-1">
          {items.map((h) => (
            <button key={`${h.kind}-${h.id}`} onClick={() => open(h)} data-testid={`radio-highlight-${h.id}`}
              className="group relative w-36 shrink-0 snap-start rounded-lg overflow-hidden bg-black border border-[#273042] hover:border-[#E11D2A]/60 transition-colors text-left">
              <div className="aspect-video">{h.thumbnail ? <img src={abs(h.thumbnail)} alt="" loading="lazy" className="w-full h-full object-cover" /> : <Film className="w-6 h-6 text-slate-600 m-auto mt-6" />}</div>
              <PlayCircle className="absolute top-4 left-1/2 -translate-x-1/2 w-8 h-8 text-white/90 group-hover:scale-110 transition-transform" />
              <div className="px-2 py-1.5 text-[11px] text-white font-semibold truncate">{h.title}</div>
            </button>))}
        </div>
      )}
      {play && <HighlightPlayer h={play} onClose={() => setPlay(null)} />}
    </div>
  );
};
